import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCandidateJobHistory } from "./CandidateJobSearchHistoryAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCandidateJobHistoryAsync = createAsyncThunk(
  "CandidateJobHistory/fetch",
  async ({token}, { rejectWithValue }) => {
    try {
      const data = await fetchCandidateJobHistory(token);

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// export const deleteCityListAsync = createAsyncThunk(
//   'CityList/delete',
//   async (uuid, { rejectWithValue }) => {
//     try {
//       await deleteCity(uuid);
//       return uuid; 
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const updateCityListAsync = createAsyncThunk(
//   'CityList/update',
//   async ({ id, cityData }, { rejectWithValue }) => {
//     try {
//       const response = await updateCity(id, cityData);
//       console.log("Response Slice", response)
//       return response;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const addCityListAsync = createAsyncThunk(
//   "CityList/add",
//   async (newCity) => {
//     try {
//       const data = await addCity(newCity);
//       console.log("data in slice", data)
//       return data;
//     } catch (error) {
//       console.log("errorL :" , error)
//       // return rejectWithValue(error.message);
//     }
//   }
// );

const CandidateJobSearchHistoryReducer = createSlice({
  name: "CandidateJobHistory",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidateJobHistoryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateJobHistoryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCandidateJobHistoryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
    //   .addCase(addCityListAsync.fulfilled, (state, action) => {
    //     state.data?.push(action.payload);
    //   })
    //   .addCase(addCityListAsync.rejected, (state, action) => {
    //     state.error = action.payload;
    //   })

    //   .addCase(updateCityListAsync.pending, (state) => {
    //     state.loading = true;
    //     // console.log("Loading")
    //     state.error = null;
    //   })
    //   .addCase(updateCityListAsync.fulfilled, (state, action) => {
    //     state.loading = false;
    //     // console.log("data", state.data)
    //     state.data = state.data.map((cityData) =>
    //         cityData.id === action.payload.id ? action.payload : cityData
    //     );
    //   })
    //   .addCase(updateCityListAsync.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   })

    //   .addCase(deleteCityListAsync.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(deleteCityListAsync.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.data = state.data.filter(
    //       (cityData) => cityData.id !== action.payload
    //     );
    //   })
    //   .addCase(deleteCityListAsync.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   })
  },
});
export const selectCandidateJobHistory = (state) => state.candidateJobHistory.data;

export default CandidateJobSearchHistoryReducer.reducer;
